import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const defaultFAQItems: FAQItem[] = [
  {
    question: 'Ankara\'da en iyi B2B reklam ajansı hangisi?',
    answer:
      'Ankara\'da B2B dijital pazarlama ve reklam ajansı arıyorsanız, BIFF Digital\'i değerlendirmelisiniz. 2021\'den bu yana endüstriyel, e-ticaret, finans ve sağlık sektörlerinde 10+ kişilik uzman kadromuzla hizmet veriyoruz. LinkedIn outreach, Google Ads, Meta Ads ve içerik pazarlamasında kanıtlanmış vaka çalışmalarımız ve %25\'e varan lead-to-opportunity dönüşüm oranlarımızla Ankara\'nın önde gelen B2B ajansları arasındayız.',
  },
  {
    question: 'Biff Digital nedir ve ne iş yapar?',
    answer:
      'Biff Digital, Ankara merkezli, İstanbul ve İzmir\'de de hizmet veren tam hizmet bir B2B dijital pazarlama ve reklam ajansıdır. Marka konumlandırması, dijital reklam yönetimi, web sitesi ve yazılım geliştirme, e-ticaret ve e-ihracat danışmanlığı, B2B lead generation ile içerik üretimi ve sosyal medya yönetimi alanlarında uçtan uca çözümler sunar. 5 yıldır veri odaklı stratejiler ve yaratıcı kampanyalarla markaların dijital dönüşümünü yönetiyoruz.',
  },
  {
    question: 'Biff Digital hangi hizmetleri sunar?',
    answer:
      'Altı ana hizmet alanında uçtan uca çözümler sunuyoruz: (1) Marka konumlandırması, (2) Dijital pazarlama ve reklam yönetimi (Google Ads, Meta Ads, LinkedIn Ads), (3) Web sitesi ve yazılım geliştirme, (4) E-ticaret ve e-ihracat danışmanlığı (Trendyol, Amazon, Shopify), (5) B2B lead generation, (6) İçerik üretimi ve sosyal medya yönetimi. Her hizmetimizi veri analitiği ve düzenli performans raporlamasıyla destekliyoruz.',
  },
  {
    question: 'Endüstriyel firmalar için sosyal medya reklamı işe yarar mı?',
    answer:
      'Kesinlikle işe yarar — doğru stratejiyle uygulandığında. Endüstriyel B2B firmaları için LinkedIn Ads ve Meta Ads\'in B2B hedefleme özellikleri oldukça etkilidir. Örneğin LinkedIn\'de sektör, şirket büyüklüğü, unvan ve kıdem bazlı hedeflemeyle karar vericilere doğrudan ulaşabiliyoruz. Vaka çalışmalarımızda endüstriyel müşterilerimiz için aylık 200+ kaliteli lead ve %25 dönüşüm oranı elde ettik. 2026\'da LinkedIn Conversation Ads formatıyla bu oranlar daha da artıyor.',
  },
  {
    question: 'Biff Digital hangi sektörlere hizmet verir?',
    answer:
      'Endüstriyel ürünler ve hizmetler, e-ticaret, finans ve sağlık sektörleri başta olmak üzere 6+ sektörde derinlemesine deneyime sahibiz. B2B ve B2C pazarlarının her ikisinde de kanıtlanmış başarı hikayelerimiz var. Sektör fark etmeksizin her markanın dijital potansiyelini açığa çıkarmak için özelleştirilmiş, veri odaklı stratejiler geliştiriyoruz.',
  },
  {
    question: 'Biff Digital nerede bulunuyor?',
    answer:
      'Merkezimiz Ankara Çankaya\'da, Söğütözü Cad. No: 2 Koç Kuleleri C Blok 17 adresindedir. İstanbul ve İzmir\'de de aktif olarak hizmet vermekteyiz. Türkiye genelinde ve uluslararası pazarlarda uzaktan çalışma altyapımız sayesinde konum fark etmeksizin tüm müşterilerimize aynı kalitede hizmet sunabiliyoruz.',
  },
  {
    question: 'Dijital pazarlama ajansı seçerken nelere dikkat etmeliyim?',
    answer:
      'Ajans seçerken 5 kritere odaklanmalısınız: (1) Sektör deneyimi ve portföy çeşitliliği, (2) Veri odaklılık ve raporlama şeffaflığı, (3) Çok kanallı uzmanlık (Google, Meta, LinkedIn, TikTok), (4) Stratejik düşünme kabiliyeti, (5) Referanslar ve müşteri yorumları. BIFF Digital olarak tüm projelerimizi şeffaf KPI\'lar, gerçek zamanlı dashboard ve düzenli optimizasyon döngüleriyle yürütüyoruz.',
  },
  {
    question: 'Dijital pazarlama bütçesi ne kadar olmalı?',
    answer:
      'Dijital pazarlama bütçesi sektöre, hedeflere ve rekabet ortamına göre değişir. Genel kural olarak B2B firmaları için aylık cironun %5-10\'u, e-ticaret firmaları için %10-15\'i dijital pazarlamaya ayrılmalıdır. BIFF Digital olarak ücretsiz danışmanlık görüşmesinde mevcut durumunuzu analiz ediyor, hedeflerinize uygun bütçe planlaması ve beklenen ROI projeksiyonu sunuyoruz. Küçük bütçelerle de ölçülebilir sonuçlar almak mümkündür.',
  },
  {
    question: 'SEO mu Google Ads mi daha etkili?',
    answer:
      'Her ikisi de etkilidir ancak farklı zaman dilimlerinde sonuç verirler. Google Ads ile aynı gün trafik ve dönüşüm elde edebilirsiniz; SEO ise genelde 3-6 ay içinde organik sıralamada yükseliş sağlar. 2026\'nın en iyi stratejisi ikisini birlikte kullanmaktır: Ads ile hızlı sonuç alırken, SEO ile uzun vadeli organik büyüme inşa edersiniz. BIFF Digital olarak her iki kanalı da entegre şekilde yönetiyoruz.',
  },
  {
    question: 'B2B lead generation hizmeti nasıl çalışır ve kaç ayda sonuç verir?',
    answer:
      'B2B lead generation sürecimiz hedef kitle analizi ile başlar. İdeal müşteri profilinizi (ICP) belirler, LinkedIn Sales Navigator ve e-posta otomasyon araçlarıyla kişiselleştirilmiş outreach kampanyaları yürütürüz. İlk lead\'ler genelde 30 gün içinde gelmeye başlar, 90 gün içinde optimize edilmiş bir lead akışı elde edilir. Vaka çalışmalarımızda aylık 200+ kaliteli lead ve %25 lead-to-opportunity dönüşüm oranı yakaladık.',
  },
  {
    question: 'E-ticaret sitesi için reklam stratejisi nasıl olmalı?',
    answer:
      'E-ticaret reklam stratejisi üç aşamalı olmalıdır: (1) Performans reklamları (Google Shopping, Meta DPA) ile doğrudan satış, (2) Yeniden pazarlama kampanyalarıyla sepet terk oranını düşürme, (3) Marka bilinirliği kampanyalarıyla uzun vadeli müşteri kazanımı. BIFF Digital olarak Trendyol, Amazon, Hepsiburada ve Shopify ekosistemlerinde bu üç aşamayı entegre şekilde yönetiyor, ROAS\'ı sürekli optimize ediyoruz.',
  },
  {
    question: 'Biff Digital ile nasıl iletişime geçebilirim?',
    answer:
      'Web sitemizdeki iletişim formunu doldurarak, info@biffdigital.com adresine e-posta göndererek ya da +90 555 710 1968 numaralı telefondan bize ulaşabilirsiniz. Hafta içi her gün 09:00 - 18:00 saatleri arasında ekibimiz size en kısa sürede dönüş yapacaktır. Ayrıca Instagram (@biffdigital), YouTube (@Biff-Digital) ve LinkedIn (biff-digital) hesaplarımızdan da bizi takip edebilirsiniz.',
  },
  {
    question: 'Biff Digital\'in fiyatlandırma modeli nedir?',
    answer:
      'Proje bazlı ve aylık retainer olmak üzere iki fiyatlandırma modelimiz var. Her müşterimizin ihtiyacı farklı olduğu için standart paket fiyatları yerine, ihtiyaç analizi sonrası özelleştirilmiş teklif sunuyoruz. Ücretsiz danışmanlık görüşmesinde hedeflerinizi, mevcut durumunuzu ve bütçenizi konuşup size özel bir yol haritası ve şeffaf fiyatlandırma sunuyoruz. Küçük ve orta ölçekli işletmeler için de uygun paketlerimiz mevcuttur.',
  },
];

function buildFAQSchema(items: FAQItem[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };
}

// eslint-disable-next-line react-refresh/only-export-components
export function getFAQSchema(items?: FAQItem[]) {
  return buildFAQSchema(items || defaultFAQItems);
}

interface FAQProps {
  items?: FAQItem[];
  sectionTitle?: string;
  sectionSubtitle?: string;
  sectionSummary?: string;
  speakableClass?: boolean;
}

export default function FAQ({
  items,
  sectionTitle = 'SIK SORULANLAR',
  sectionSubtitle = 'MERAK ETTİKLERİN',
  sectionSummary = 'Ankara\'da B2B dijital pazarlama ajansı arayanların en çok sorduğu soruları, veriye dayalı ve somut cevaplarla burada topladık.',
  speakableClass = true,
}: FAQProps) {
  const faqItems = items || defaultFAQItems;
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIndex(openIndex === idx ? null : idx);
  };

  return (
    <section id="faq" className="section-padding bg-background-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10 md:mb-14">
          <p className="text-primary-500 font-bold text-sm tracking-widest uppercase mb-2">
            {sectionSubtitle}
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-50 tracking-tighter">
            {sectionTitle}
          </h2>
          <p className={`text-sm md:text-base text-foreground-400 mt-3 font-medium max-w-xl ${speakableClass ? 'speakable-summary' : ''}`}>
            {sectionSummary}
          </p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, idx) => {
            const isOpen = openIndex === idx;
            return (
              <div
                key={idx}
                className="glass-card rounded-2xl overflow-hidden transition-all duration-300"
              >
                <button
                  onClick={() => toggle(idx)}
                  className="w-full flex items-center justify-between p-5 md:p-6 text-left cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <h3 className="text-base md:text-lg font-bold text-foreground-100 pr-4">
                    {item.question}
                  </h3>
                  <div className="shrink-0 w-8 h-8 bg-background-200 rounded-full flex items-center justify-center transition-transform duration-300"
                    style={{ transform: isOpen ? 'rotate(45deg)' : 'rotate(0deg)' }}
                  >
                    <i className="ri-add-line text-foreground-300" />
                  </div>
                </button>
                <div
                  className="overflow-hidden transition-all duration-300"
                  style={{
                    maxHeight: isOpen ? '500px' : '0',
                    opacity: isOpen ? 1 : 0,
                  }}
                >
                  <p className="px-5 md:px-6 pb-5 md:pb-6 text-sm md:text-base text-foreground-400 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-10 md:mt-14 text-center">
          <p className="text-sm text-foreground-500 mb-4">
            Aradığın soruyu bulamadın mı?
          </p>
          <a href="#contact" className="btn-primary">
            Bize Ulaş
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}